import { createApp } from 'vue'
import App from './App.vue'
import vuetify from "./plugins/vuetify";
import posthogPlugin from "./plugins/posthog";
import router from '../router/index.js';
import store from '../store/index.js';
import './assets/css/common.css';

import { library } from '@fortawesome/fontawesome-svg-core'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { fas } from '@fortawesome/free-solid-svg-icons'

import PrimeVue from 'primevue/config';
import Noir from './presets/Noir.js';
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";

library.add(fas)

const app = createApp(App);
app.use(router)
app.use(vuetify)
app.use(PrimeVue, {
    theme: {
        preset: Noir,
        options: {
            prefix: 'p',
            darkModeSelector: '.p-dark',
            cssLayer: false,
        }
    }
})
app.use(ToastService)
app.use(ConfirmationService)
app.use(store)
app.use(posthogPlugin)

// Initialize authentication from localStorage on app startup
store.dispatch('initializeAuth')

// eslint-disable-next-line vue/component-definition-name-casing
app.component('font-awesome-icon', FontAwesomeIcon).mount('#app')
